import { QueryResponseData } from '~/listing/typings';

import MyCharacters from '../listing/MyCharacters';

interface Props {
    characterQuery: {
        isLoading: boolean;
        data: QueryResponseData | undefined;
        refetch: () => void;
        error: Error | null;
    };
}
export default function Listing({ characterQuery }: Props) {
    return <MyCharacters characterQuery={characterQuery} />;
}
